/*
  PDP V2 Complete the Matching Kit.
  - Size change: copies the chosen variant id into the row's hidden input and shows that
    variant's price and compare-at reference in the same row. A row in the Matching Kit offer
    (its options carry data-kit-price) shows the chosen size's price with this jersey and its
    price if purchased separately; the saving is the same for every size and is not recomputed.
  - Add to Cart: hands the row's button to Broadcast's cart (`theme:cart:add`). The theme
    validates the row form (a size must be chosen), posts it, and refreshes the drawer and
    count. Nothing here touches the main product form.
  - Add to Cart with no size chosen: the card says "Please select a size" under its size control
    (announced, and tied to the control) and the control takes the focus. Nothing is sent to the
    cart. Choosing a size removes the message.
*/
(function () {
  if (window.joyMatchingKitReady) return;
  window.joyMatchingKitReady = true;

  function sizeError(row, select, on) {
    var form = select.closest('form');
    var message = row.querySelector('[data-joy-kit-size-error]');
    if (!on) {
      if (message) message.hidden = true;
      select.removeAttribute('aria-invalid');
      select.removeAttribute('aria-describedby');
      return;
    }
    if (!message) {
      message = document.createElement('p');
      message.className = 'joy-kit__size-error';
      message.id = select.id + '-error';
      message.setAttribute('data-joy-kit-size-error', '');
      message.setAttribute('role', 'alert');
      form.appendChild(message);
    }
    message.hidden = false;
    message.textContent = 'Please select a size';
    select.setAttribute('aria-invalid', 'true');
    select.setAttribute('aria-describedby', message.id);
    select.focus();
  }

  document.addEventListener('change', function (event) {
    var select = event.target.closest && event.target.closest('[data-joy-kit] [data-joy-kit-select]');
    if (!select) return;
    var option = select.options[select.selectedIndex];
    var row = select.closest('[data-joy-kit-row]');
    if (!option || !option.value || !row) return;
    sizeError(row, select, false);
    var id = row.querySelector('[data-joy-kit-id]');
    if (id) id.value = option.value;
    var price = row.querySelector('[data-joy-kit-price]');
    var compare = row.querySelector('[data-joy-kit-compare]');
    // A size is chosen: the row states that size's prices, no longer "From ...".
    var from = row.querySelectorAll('[data-joy-kit-from]');
    for (var i = 0; i < from.length; i++) from[i].hidden = true;
    var kitPrice = option.getAttribute('data-kit-price');
    var standalone = row.querySelector('[data-joy-kit-standalone]');
    if (kitPrice && standalone) {
      if (price) price.textContent = kitPrice;
      standalone.textContent = option.getAttribute('data-price');
      return;
    }
    if (price) price.textContent = option.getAttribute('data-price');
    if (compare) {
      var c = option.getAttribute('data-compare');
      compare.textContent = c ? (compare.hasAttribute('data-joy-kit-compare-plain') ? c : '(' + c + ' if purchased separately)') : '';
    }
  });

  document.addEventListener('click', function (event) {
    var button = event.target.closest && event.target.closest('[data-joy-kit] [data-joy-kit-add]');
    if (!button || button.disabled) return;
    event.preventDefault();
    var row = button.closest('[data-joy-kit-row]');
    var select = row && row.querySelector('[data-joy-kit-select]');
    if (select && !select.value) {
      sizeError(row, select, true);
      return;
    }
    if (window.a11y) window.a11y.lastElement = button;
    document.dispatchEvent(new CustomEvent('theme:cart:add', { detail: { button: button } }));
  });
})();
